import React, {useState, useEffect, createContext } from 'react';
import { useApp } from '../context/app-context';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import { NocScreen } from '../pages/Dashboard/NocScreen';
import { NavBar } from '../components/Dashboard/layouts/NavBar'
import { AccountScreen } from '../pages/Dashboard/AccountScreen/AccountScreen';
import { AccessScreen } from '../pages/Dashboard/AccessScreen';
import { EditUserAccountScreen } from '../pages/Dashboard/AccountScreen/EditUserAccountScreen';
import { UpdateManagerScreen } from '../pages/Dashboard/UpdateManagerScreen';
import { StationScreen } from '../pages/Dashboard/StationScreen';
import { loadUserData } from '../services/UserService';
import { PasswordExpiredScreen } from '../pages/Dashboard/PasswordExpiredScreen';
import { getUserPermissions, isAdmin } from '../UserValidation';
import ReactErrorBoundary from './ReactErrorBoundary';

export const PermissionsContext = createContext(undefined);

export const DashboardRoutes = () => {
    
    const {state: {user}} = useApp();
    const { passwordReset } = user;
    const { dispatch } = useApp();

    const [account, setAccount] = useState(undefined)
    const [pendingChangesModal, setPendingChangesModal] = useState(false);
    const [pendingState, setPendingState] = useState(false);

    useEffect(() => {
        loadUserData().then( function(response) {
            setAccount(response);
            dispatch({type: 'update-user', payload: {...user, ...response}})
        })
    }, [])

    return (
        <> { !passwordReset ? 
                <ReactErrorBoundary>
                    <PermissionsContext.Provider value={getUserPermissions(user)}>
                        <Layout style={{minHeight: "100vh"}}>
                            <NavBar pendingState={pendingState} pendingChangesModal={pendingChangesModal} setPendingChangesModal={setPendingChangesModal} />
                            <Routes>
                                {/* Authenticated routes */}
                                <Route path="/" element={ <NocScreen /> } />
                                <Route index element={<NocScreen />} />
                                <Route path="/station" element={ <StationScreen pendingState={pendingState} setPendingState={setPendingState} pendingChangesModal={pendingChangesModal} setPendingChangesModal={setPendingChangesModal} /> } />
                                <Route path="/access-management" element={ <AccessScreen /> } />
                                { user.serverType === 'PCI' &&
                                    <Route path="/update-manager" element={ isAdmin(user) ? (<UpdateManagerScreen /> ) : (<Navigate replace to={"/"} />) } />
                                }
                                <Route path="/account" element={ <AccountScreen account={account}/> } />
                                <Route path="/edit-user" element={ <EditUserAccountScreen /> } />
                                <Route
                                    path="*"
                                    element={<Navigate to="/" replace />}
                                />
                            </Routes>
                        </Layout>
                    </PermissionsContext.Provider>
                </ReactErrorBoundary>
                : 
                <Layout style={{minHeight: "100vh"}}>
                    <PasswordExpiredScreen account={account}/>
                </Layout>
            }
        </>
    )
}
